import { Activity, Clock } from 'lucide-react'
import type { PortalData } from '@/types/portalCliente'

export function PortalClienteTimelineSection({ data }: { data: PortalData }) {
  return (
    <section className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-5 space-y-4">
      <h2 className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-2">
        <Activity size={14} />
        Timeline de Interações
      </h2>
      {data.interacoes.length === 0 ? (
        <p className="text-sm text-white/40 italic py-4 text-center">Nenhuma interação registrada.</p>
      ) : (
        <div className="space-y-1">
          {data.interacoes.map((interacao, i) => (
            <div key={interacao.id} className="relative pl-6 pb-5 last:pb-0">
              {i < data.interacoes.length - 1 && (
                <div className="absolute left-[7px] top-4 bottom-0 w-px bg-white/[0.06]" />
              )}
              <div className="absolute left-0 top-1.5 w-3.5 h-3.5 rounded-full border-2 border-[#0a0a0f] bg-accent" />
              <div className="rounded-lg bg-white/[0.02] p-3 space-y-1">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-medium text-accent uppercase tracking-wider">
                    {interacao.tipo}
                  </span>
                  <span className="text-[10px] text-white/30 flex items-center gap-1">
                    <Clock size={10} />
                    {new Date(interacao.data).toLocaleDateString('pt-BR', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </span>
                </div>
                {interacao.descricao && <p className="text-sm text-white/70">{interacao.descricao}</p>}
                {interacao.resultado && (
                  <p className="text-xs text-white/50">Resultado: {interacao.resultado}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}
